<template>
    <div class="sustainability-wrapper">
      <app-header></app-header>
      <div class="sustainability-content">
        <app-aside :linksArray="links"></app-aside>
        <div class="sustainability-content-main">
          <app-environment v-if="this.$route.params.page == 'environment'"></app-environment>
          <app-health-and-safety v-if="this.$route.params.page == 'health-and-safety'"></app-health-and-safety>
          <app-responsibility v-if="this.$route.params.page == 'responsibility'"></app-responsibility>
        </div>
      </div>
    </div>
</template>

<script>
import Header from "./sustainability/Header";
import Aside from "./shared/Aside";
import Environment from "./sustainability/Environment";
import Responsibility from "./sustainability/Responsibility";
import HealthAndSafety from "./sustainability/HealthAndSafety";
export default {
  components: {
    appHeader: Header,
    appAside: Aside,
    appEnvironment: Environment,
    appResponsibility: Responsibility,
    appHealthAndSafety: HealthAndSafety
  },
  data() {
    return {
      links: [
        { name: "Ambiente", url: "/sustainability/environment" },
        {
          name: "Salute e sicurezza",
          url: "/sustainability/health-and-safety"
        },
        { name: "Responsabilità", url: "/sustainability/responsibility" }
      ]
    };
  },
  watch: {
    $route(to, from) {
      //      this.isPageExisting();
    }
  },
  methods: {
    isPageExisting() {
      switch (this.$route.params.page) {
        case "environment":
          break;
        default:
          this.$router.replace("../404");
      }
    }
  },
  mounted() {
    //    this.isPageExisting();
  }
};
</script>

<style scoped>
.sustainability-content {
  display: flex;
}
.sustainability-content-main {
  width: 80%;
}
@media screen {
  .sustainability-content-main {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Sustainability.vue